import {SchedulerEventLogEntry, SchedulerEventLogType} from "@models";
import {Component, inject, Injector, OnInit} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {TranslateService} from "@ngx-translate/core";

export interface JOBLOG_DIALOG_INPUT extends MatDialogDataBaseInput {
	title: string;
	okText: string;
	jobLogs: SchedulerEventLogEntry[];
}

@Component({
	selector: "sim-job-log-dialog",
	templateUrl: "./job-log-dialog.component.html",
	styleUrls: ["./job-log-dialog.component.scss"],
	standalone: false,
})
export class JobLogDialogComponent extends BasicMaterialDialog<JobLogDialogComponent, JOBLOG_DIALOG_INPUT> implements OnInit {
	readonly translate = inject(TranslateService);
	SchedulerEventLogType = SchedulerEventLogType;
	displayedColumns: string[] = ["createdOn", "type", "name", "text"];
	constructor(_injector: Injector) {
		super(_injector);
	}
}
